import { FeatureFlag, Role } from '@/contexts/Settings.types';
import { globalAdminRoutes } from '@/layouts/layout.constants';

export type MenuItem =
  | string
  | {
      name: string;
      description?: string;
      url?: string;
      roles?: Role[];
    };

type ItemSet = {
  items: MenuItem[];
  roles: Role[];
};

export type Page =
  | string
  | Record<
      string,
      {
        itemSets?: ItemSet[];
        image?: string;
        roles?: Role[];
        showAtEnd?: boolean;
        url?: string;
      }
    >;

export const getPages = (features: FeatureFlag[] | undefined, isSocialFeedEnabled?: boolean): Page[] => {
  return [
    'Home',
    {
      Strategies: {
        roles: [Role.Designer, Role.Admin, Role.GlobalAdmin, Role.Collaborator]
      }
    },
    ...(!isSocialFeedEnabled
      ? [
          {
            Collaborate: {
              roles: [Role.Collaborator, Role.Designer, Role.Admin, Role.GlobalAdmin]
            }
          }
        ]
      : []),
    {
      Report: {
        itemSets: [
          {
            items: [
              {
                name: 'Our Journey',
                description: 'A report that shows the overall journey of the strategy.'
              },
              {
                name: 'Our Calendar',
                description: 'Display your contributions and periods.',
                roles: [Role.Collaborator, Role.Designer, Role.Admin, Role.GlobalAdmin]
              },
              {
                name: 'Our Updates',
                description: 'Find everything about the user activities.',
                roles: [Role.Collaborator, Role.Designer, Role.Admin, Role.GlobalAdmin]
              },
              {
                name: 'Our Songline',
                description: ''
              },
              {
                name: 'Photo Album',
                description: ''
              }
            ],
            roles: [Role.Collaborator, Role.Designer, Role.Admin, Role.GlobalAdmin, Role.LightUser]
          }
        ]
      }
    },
    {
      Admin: {
        itemSets: [
          {
            items: [
              {
                name: 'Users',
                description: 'Manage users.',
                url: '/admin/subscription?tab=users'
              },
              {
                name: 'Subscription',
                description: 'Manage subscription.'
              }
            ],
            roles: [Role.Admin, Role.GlobalAdmin]
          },
          {
            items: [
              {
                name: 'Business Units',
                description: 'Manage business units.'
              },
              {
                name: 'All Subscriptions',
                description: 'Manage All Subscriptions.',
                url: globalAdminRoutes.allSubscriptions
              },
              {
                name: 'All Users',
                description: 'Manage All Users.',
                url: globalAdminRoutes.allUsers
              },
              {
                name: 'App Lookups',
                description: 'Manage system configurations',
                url: globalAdminRoutes.appLookups
              },
              {
                name: 'App Modules',
                description: 'Manage system modules',
                url: globalAdminRoutes.appModules
              },
              {
                name: 'Scheduler',
                description: 'Scheduler',
                url: globalAdminRoutes.scheduler
              },
              {
                name: 'Content Builder',
                description: 'Content Builder',
                url: globalAdminRoutes.contentBuilder
              },
              {
                name: 'System',
                description: 'System Info',
                url: globalAdminRoutes.system
              }
            ],
            roles: [Role.GlobalAdmin]
          }
        ],
        roles: [Role.Admin, Role.GlobalAdmin]
      }
    },
    {
      Resources: {
        itemSets: [
          {
            items: [
              { name: 'Terms and conditions', url: '/terms' },
              { name: 'Privacy policy', url: '/privacy_policy' },
              { name: 'Security', url: '/security' },
              { name: 'Our Use of AI', url: '/our_use_of_ai' },
              ...(features?.includes('CaseStudies') ? [{ name: 'Case Studies', url: '/casestudies' }] : []),
              ...(features?.includes('Blogs') ? [{ name: 'Blogs', url: '/blogs' }] : []),
              ...(features?.includes('KnowledgeBase')
                ? [
                    {
                      name: 'Knowledge Base',
                      url: '/knowledgebase'
                    }
                  ]
                : [])
            ],
            roles: [Role.Collaborator, Role.Designer, Role.Admin, Role.GlobalAdmin, Role.LightUser]
          }
        ]
      }
    }
  ];
};
